<!--三个按钮的Confirm组件-->
<template>
    <a-modal v-model="visible" :title=this.title style="text-align: center" :width=this.width :maskClosable="false" :closable="true" :footer="null">
        <a-row style="margin-top: 10px">
            <a-col style="font-size: large;text-align:left;margin-left: 10px">
                {{this.content}}
            </a-col>
        </a-row>
        <br>
        <a-row>
            <a-col span="5" offset="0">
                <a-button class="btnCancelWidth" type="primary" @click="closeWindow(1)">{{ this.leftBtnName }}</a-button>
            </a-col>
            <a-col span="3">
                <a-button class="btnWidth" @click="closeWindow(2)">{{ this.centerBtnName }}</a-button>
            </a-col>
            <a-col span="3" >
                <a-button class="btnWidth" type="danger" @click="closeWindow(3)">{{ this.rightBtnName }}</a-button>
            </a-col>
        </a-row>
        <br>
    </a-modal>
</template>
<script>
    export default{
        data(){
            return{
                visible: false,//是否显示弹出窗
                title:"",//弹出窗的标题
                width:'30%',//弹出窗的宽度
                content:'提示内容',
                leftBtnName:'左侧按钮名称',
                centerBtnName:'中间按钮名称',
                rightBtnName:'右侧按钮名称',
            }
        },
        methods:{
            show(param){
                this.visible = true
                this.title = param.title != null && param.title.length > 0 ? param.title : ''
                this.width = param.width != null && param.width.length > 0 ? param.width : this.width
                this.content = param.content != null && param.content.length > 0 ? param.content : this.content
                this.leftBtnName = param.leftBtnName != null && param.leftBtnName.length > 0 ? param.leftBtnName : this.leftBtnName
                this.centerBtnName = param.centerBtnName != null && param.centerBtnName.length > 0 ? param.centerBtnName : this.centerBtnName
                this.rightBtnName = param.rightBtnName != null && param.rightBtnName.length > 0 ? param.rightBtnName : this.rightBtnName
            },
            closeWindow(val){
                this.visible = false;
                this.$emit("closeWindowBack", val);
            },
        }
    }
</script>
<style>
    .btnWidth{
        width: 50px;
        margin-left: 260px;
    }
    .btnCancelWidth{
        width: 100px;
        margin-left: 10px;
    }
</style>